import { useReducer, createContext } from "react"
import { BrowserRouter as Router, Routes, Route } from "react-router-dom"
import { config as c, brand } from "./_config/config"
import { Home } from "./routes/Home"
import { Login } from "./routes/Login"
import { Backdoor } from "./routes/Backdoor.js"

const b = window.location.hostname.includes("fastquote")
      ? 'fastquote'
      : window.location.hostname.includes("boxguard")
            ? 'boxguard'
            : 'dasher'

const e = window.location.hostname.includes("stage") || window.location.hostname.includes("local") ? 'stage' : 'prod'

export const MyContext = createContext()

export default function App() {

      const [AppData, setAppData] = useReducer((oldData, newItem) => { return ({ ...oldData, ...newItem }) }, { version: "1.23.33", brand: b, ...c[e], ...brand[b] })
      const [UserData, setUserData] = useReducer((oldData, newItem) => { return ({ ...oldData, ...newItem }) }, { authenticated: false })

      if (UserData.authenticated) {

            return (
                  <MyContext.Provider value={{ AppData, setAppData, UserData, setUserData }}>
                        <Router>
                              <Routes>
                                    <Route path="/" element={<Home />} />
                              </Routes>
                        </Router>
                  </MyContext.Provider>
            )

      }

      else {

            return (
                  <MyContext.Provider value={{ AppData, setAppData, UserData, setUserData }}>
                        <Router>
                              <Routes>
                                    <Route path="/backdoor" element={<Backdoor />} />
                                    <Route path="*" element={<Login />} />
                              </Routes>
                        </Router>
                  </MyContext.Provider>
            )

      }


}
